import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { AffordabilityServiceState } from '../../models';
import { AffordabilityService } from '../../services';
import { AffordabilityFormComponent } from '../affordability-form/affordability-form.component';
import { CurrencyPipe, NgClass } from '@angular/common';
import { ResultsEditSearchComponent } from '../../components/results-edit-search/results-edit-search.component';

@Component({
  templateUrl: 'results.component.html',
  styleUrls: ['./results.component.scss'],
  imports: [AffordabilityFormComponent, NgClass, ResultsEditSearchComponent, CurrencyPipe],
})
export class ResultsComponent {
  public readonly affordabilityService = inject(AffordabilityService);

  @ViewChild('topSuccessDescription', { static: true })
  public topSuccessDescription: ElementRef<HTMLInputElement>;

  @ViewChild('topDeclinedDescription', { static: true })
  public topDeclinedDescription: ElementRef<HTMLInputElement>;

  @ViewChild('topLowerAmountDescription', { static: true })
  public topLowerAmountDescription: ElementRef<HTMLInputElement>;

  @ViewChild('bottomSuccessDescription', { static: true })
  public bottomSuccessDescription: ElementRef<HTMLInputElement>;

  @ViewChild('bottomLowerAmountDescription', { static: true })
  public bottomLowerAmountDescription: ElementRef<HTMLInputElement>;

  public window: Window;

  public constructor() {
    this.window = window;
  }

  public get loading() {
    return this.affordabilityService.state === AffordabilityServiceState.Loading;
  }

  public get topMessage() {
    return this.affordabilityService.resultTopMsg;
  }

  public get bottomMessage() {
    return this.affordabilityService.resultBtmMsg;
  }

  public get errored() {
    return this.affordabilityService.state === AffordabilityServiceState.Errored;
  }

  public get loanAmountText() {
    return this.affordabilityService.resultLoanAmountText;
  }
}
